/* unplugin-vue-components disabled */import { render } from "./mg-docs.vue?vue&type=template&id=3f5ae4cb&scoped=true"
import script from "./mg-docs.vue?vue&type=script&lang=js"
export * from "./mg-docs.vue?vue&type=script&lang=js"

import "./mg-docs.vue?vue&type=style&index=0&id=3f5ae4cb&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5ae4cb"],['__file',"src/pages/settings/admin/mongo/mg-docs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f5ae4cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f5ae4cb', __exports__)) {
    api.reload('3f5ae4cb', __exports__)
  }
  
  module.hot.accept("./mg-docs.vue?vue&type=template&id=3f5ae4cb&scoped=true", () => {
    api.rerender('3f5ae4cb', render)
  })

}


export default __exports__